import React from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardList } from "lucide-react";

import { Button } from "components/ui/Button";
import { usePatientTasks } from "features/comunications/hooks/usePatientTasks";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { pathGenerators } from "utils/routes";

import s from "./TasksSummary.module.css";

const TasksSummary = () => {
  const navigate = useNavigate();
  const patientId = useCurrentPatientId();
  const { data: tasksData, isLoading } = usePatientTasks({
    patientId,
    page: 1,
    rows: 100,
  });

  if (isLoading) return null;

  const tasks = tasksData?.data || tasksData || [];
  const openTasks = tasks.filter(
    (task) => task.status !== "Complete"
  );

  if (openTasks.length === 0) return null;

  const goToTasks = () =>
    navigate(pathGenerators.patient.tasks(patientId));

  return (
    <div className={`${s.wrapper} ${s.open}`}>
      <div className={s.iconWrap}>
        <ClipboardList size={20} />
      </div>
      <div className={s.content}>
        <p className={s.count}>
          {openTasks.length} open {openTasks.length === 1 ? "task" : "tasks"}
        </p>
        <p className={s.description}>
          {`Requires attention`}
        </p>
      </div>
      <Button variant="primary" size="small" onClick={goToTasks}>
        View Tasks
      </Button>
    </div>
  );
};

export { TasksSummary };
